import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import HangmanGoCard from "./HangmanGoCard";
import WordPopCard from "./WordPopCard";
import OneToFiftyCard from "./OneToFiftyCard";
import DotsplosionCard from "./DotsplosionCard";
import PurpleTrapCard from "./PurpleTrapCard";
import Particle from "../Particle";
import bitsOfCode from "../../Assets/Projects/resmigazeteios2.png";
import hangmanGo from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.02.11.png";
import wordpop from "../../Assets/Projects/wordpop/wordpop_store_01.png";
import to50 from "../../Assets/Projects/1to50/1to50_store_01.png";
import dotsplosion from "../../Assets/Projects/dotsplosion/01_massive_chain_reactions.png";
import purpletrap from "../../Assets/Projects/purpletrap/01_title.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've individually developed recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <PurpleTrapCard
              imgPath={purpletrap}
            />
          </Col>

          <Col md={4} className="project-card">
            <DotsplosionCard
              imgPath={dotsplosion}
            />
          </Col>

          <Col md={4} className="project-card">
            <WordPopCard
              imgPath={wordpop}
            />
          </Col>

          <Col md={4} className="project-card">
            <HangmanGoCard
              imgPath={hangmanGo}
            />
          </Col>

          <Col md={4} className="project-card">
            <OneToFiftyCard
              imgPath={to50}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Resmi Gazete IOS & Android"
              description="Official Gazette of the Republic of Turkey IOS and Android Applications.It was published in app stores from 2013 until the end of 2019. Applications reached more than 300,000 unique users. It received more than 20000 votes and comments and achieved an average rating of 4.5 out of 5."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
